@if (loading()) {
  <app-circular-progress class="app-button__circular-progress" />
}

<ng-content select="[appButtonIcon]:not([iconPositionEnd])" />

<span class="app-button__label"><ng-content></ng-content></span>

<ng-content select="[appButtonIcon][iconPositionEnd]" />
